import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/KebunLP.css";
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
  PieChart, Pie, Cell
} from 'recharts';

const KebunDetailPabrik = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  
  const pabrikInfo = location.state?.pabrikInfo || {};
  
  const [trenCpo, setTrenCpo] = useState([]);
  const [komposisi, setKomposisi] = useState([]);
  const [riwayatTabel, setRiwayatTabel] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tanggal, setTanggal] = useState("");
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  const COLORS = ['#198754', '#f6c23e', '#e74a3b', '#36b9cc', '#4e73df', '#858796', '#5a5c69'];

  const formatNumber = (value) => {
    if (value === null || value === undefined || isNaN(Number(value))) return "0";
    return new Intl.NumberFormat("id-ID").format(value);
  };

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    const fetchUserInfo = async () => {
      try {
        const response = await axios.get(
          "https://c-greenproject.org:7500/get_user_role",
          { withCredentials: true }
        );
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };

    const fetchData = async () => {
      try {
        const headers = { Authorization: `Bearer ${localStorage.getItem("token")}` };
        
        const [resTren, resKomposisi, resTabel] = await Promise.all([
          axios.get(`https://c-greenproject.org:7500/grafik/pabrik/${id}/tren_cpo`, { headers }),
          axios.get(`https://c-greenproject.org:7500/grafik/pabrik/${id}/komposisi_terakhir`, { headers }),
          axios.get(`https://c-greenproject.org:7500/pabrik/${id}/produksi`, { headers })
        ]);

        if (resTren.data.data) setTrenCpo(resTren.data.data);
        if (resKomposisi.data.data) setKomposisi(resKomposisi.data.data);
        if (resTabel.data.data_produksi) setRiwayatTabel(resTabel.data.data_produksi);

      } catch (error) {
        Swal.fire("Error", "Gagal memuat data analitik pabrik.", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchUserInfo();
    fetchData();
  }, [id]);

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
      Swal.fire("Gagal", "Gagal logout. Silakan coba lagi.", "error");
    }
  };

  return (
    <div className="d-flex flex-column bg-light min-vh-100">
      
      {/* Header Standar */}
      <div className="header bg-white shadow-sm border-bottom">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span className="fw-medium text-secondary">{userInfo.full_name} |</span>
          <button
            className="btn btn-outline-danger btn-sm rounded-pill px-3 ms-2"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        
        {/* Sidebar Standar */}
        <div className="sidebar p-3 bg-white shadow-sm" id="sidebar">
          <p id="sidebar-title" className="text-muted small mb-1">Portal Sistem Traceability</p>
          <h6 id="sidebar-subtitle" className="fw-bold text-success mb-3">Telsa Super Apps</h6>
          <p id="sidebar-date" className="bg-light p-2 rounded-3 text-muted small fw-medium d-flex align-items-center gap-2">
            <img src="/static/schedule_11145854.png" alt="Date" style={{ width: "16px" }} />
            {tanggal}
          </p>
          <div className="list-group list-group-flush mt-3" id="sidebar-menu">
            <div
              onClick={() => navigate("/kebun")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/kebun" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/kebun" ? "brightness(0) invert(1)" : "none" }} /> Beranda
            </div>
            <div
              onClick={() => navigate("/KebunP")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/KebunP" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/Tanam.png" alt="Planting" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/KebunP" ? "brightness(0) invert(1)" : "none" }} /> Petani
            </div>
            <div
              onClick={() => navigate("/KebunL")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/KebunL" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/shipping.png" alt="Logistics" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/KebunL" ? "brightness(0) invert(1)" : "none" }} /> Logistik
            </div>
            <div
              onClick={() => navigate("/kebunpabrik")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname.includes("/kebunpabrik") ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/factory.png" alt="Factory" style={{ width:"20px", marginRight:"10px", filter: location.pathname.includes("/kebunpabrik") ? "brightness(0) invert(1)" : "none" }} /> Pabrik
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content flex-grow-1 p-4 w-100">
          
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="fw-bold text-dark mb-0">Analitik & Rincian Pabrik</h2>
            <button className="btn btn-outline-secondary btn-sm rounded-pill px-4 shadow-sm" onClick={() => navigate(-1)}>
              <i className="fa fa-arrow-left me-2"></i> Kembali
            </button>
          </div>

          <div className="divider mb-4"></div>
          
          {/* Kartu Info Pabrik */}
          <div className="bg-white p-4 rounded-4 shadow-sm mb-4 border-start border-success border-4">
            <h3 className="fw-bold text-dark mb-1">{pabrikInfo.nama || "Detail Pabrik"}</h3>
            <p className="text-muted mb-0"><i className="fa fa-map-marker-alt me-2"></i>{pabrikInfo.alamat_pabrik || "-"}</p>
            <hr />
            <div className="row text-center">
              <div className="col-md-3">
                <div className="text-muted small">Status</div>
                <div className="fw-bold text-success h5">{pabrikInfo.status_penerimaan || "-"}</div>
              </div>
              <div className="col-md-3">
                <div className="text-muted small">Truk Menuju Pabrik</div>
                <div className="fw-bold text-primary h5">{pabrikInfo.truk_menuju_pabrik || 0} Unit</div>
              </div>
              <div className="col-md-3">
                <div className="text-muted small">Kapasitas Tersedia</div>
                <div className="fw-bold text-dark h5">{formatNumber(pabrikInfo.kapasitas_tersedia)} Kg</div>
              </div>
              <div className="col-md-3">
                <div className="text-muted small">Terakhir Diperbarui</div>
                <div className="fw-bold text-secondary">{pabrikInfo.terakhir_diperbarui || "-"}</div>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-success" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="text-muted mt-2">Memuat grafik analitik...</p>
            </div>
          ) : (
            <>
              {/* Area Grafik */}
              <div className="row mb-4">
                <div className="col-lg-8 mb-4 mb-lg-0">
                  <div className="bg-white p-4 rounded-4 shadow-sm h-100">
                    <h6 className="fw-bold text-success mb-4">Tren Produksi CPO</h6>
                    <ResponsiveContainer width="100%" height={300}>
                      <LineChart data={trenCpo} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
                        <Line type="monotone" dataKey="cpo" stroke="#198754" strokeWidth={3} dot={{ r: 4 }} activeDot={{ r: 8 }} />
                        <CartesianGrid stroke="#ccc" strokeDasharray="5 5" vertical={false} />
                        <XAxis dataKey="waktu" tick={{ fontSize: 12 }} />
                        <YAxis tick={{ fontSize: 12 }} width={80} />
                        <Tooltip formatter={(value) => [`${formatNumber(value)} Kg`, 'CPO']} />
                        <Legend />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </div>

                <div className="col-lg-4">
                  <div className="bg-white p-4 rounded-4 shadow-sm h-100 d-flex flex-column align-items-center">
                    <h6 className="fw-bold text-success mb-3 w-100 text-start">Komposisi Produksi Terakhir</h6>
                    <ResponsiveContainer width="100%" height={250}>
                      <PieChart>
                        <Pie data={komposisi} innerRadius={60} outerRadius={90} paddingAngle={2} dataKey="value">
                          {komposisi.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                          ))}
                        </Pie>
                        <Tooltip formatter={(value) => `${formatNumber(value)} Kg`} />
                      </PieChart>
                    </ResponsiveContainer>
                    
                    <div className="mt-3 w-100 d-flex flex-wrap justify-content-center gap-2" style={{ fontSize: "0.75rem" }}>
                      {komposisi.map((entry, index) => (
                        <div key={index} className="d-flex align-items-center">
                          <span style={{ display: 'inline-block', width: '10px', height: '10px', backgroundColor: COLORS[index % COLORS.length], marginRight: '5px', borderRadius: '2px'}}></span>
                          {entry.name}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Tabel Data Historis */}
              <div className="bg-white p-4 rounded-4 shadow-sm">
                <h6 className="fw-bold text-dark mb-3">Data Historis Tabel Produksi</h6>
                <div className="table-responsive">
                  <table className="table table-hover table-bordered table-sm align-middle text-center" style={{ fontSize: "0.85rem" }}>
                    <thead className="table-light">
                      <tr>
                        <th style={{ minWidth: "120px" }}>Waktu (WIB)</th>
                        <th className="text-success">CPO</th>
                        <th>T. Kosong</th>
                        <th>Cangkang</th>
                        <th>Sabut</th>
                        <th>Bungkil</th>
                        <th>Sludge</th>
                        <th>POME</th>
                      </tr>
                    </thead>
                    <tbody>
                      {riwayatTabel.map((item, index) => {
                        const displayWaktu = item.waktu_produksi ? item.waktu_produksi.replace(" ", "<br/>") : "-";
                        return (
                          <tr key={index}>
                            <td className="text-secondary" dangerouslySetInnerHTML={{ __html: displayWaktu }}></td>
                            <td className="font-monospace fw-bold text-success text-nowrap">{formatNumber(item.hasil_cpo)}</td>
                            <td className="font-monospace text-nowrap">{formatNumber(item.limbah_produksi.tandan_kosong)}</td>
                            <td className="font-monospace text-nowrap">{formatNumber(item.limbah_produksi.cangkang)}</td>
                            <td className="font-monospace text-nowrap">{formatNumber(item.limbah_produksi.sabut)}</td>
                            <td className="font-monospace text-nowrap">{formatNumber(item.limbah_produksi.bungkil)}</td>
                            <td className="font-monospace text-nowrap">{formatNumber(item.limbah_produksi.sludge)}</td>
                            <td className="font-monospace text-nowrap">{formatNumber(item.limbah_produksi.pome)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default KebunDetailPabrik;